import { MobileRouterPaths } from "../../mobileAppConstants";
import { IMobileMenuItemConfig } from "./mobileMenu.t";
import { LOCATION_NAMES } from "../../../modules/Location/locationConstants";
import { getIsAcademyEnabledSelector } from "../../../modules/Academy/academySelectors";
import { getShowMobileMenuProfileBadgeSelector } from "./mobileMenuSelectors";

export const MOBILE_MENU_ITEM_CONFIGS_LIST: IMobileMenuItemConfig[] = [{
    icon: 'IcPortfolio',
    locationName: LOCATION_NAMES.HOME,
    title: 'menu.home',
    to: MobileRouterPaths.portfolio,
}, {
    icon: 'IcChartStatistic',
    locationName: LOCATION_NAMES.MARKET,
    title: 'menu.market',
    to: MobileRouterPaths.market,
}, {
    icon: 'IcBookClosed',
    isVisibleSelector: getIsAcademyEnabledSelector,
    locationName: LOCATION_NAMES.ACADEMY,
    title: 'menu.academy',
    to: MobileRouterPaths.academy,
}, {
    icon: 'IcPerson',
    isShowBadgeSelector: getShowMobileMenuProfileBadgeSelector,
    locationName: LOCATION_NAMES.PROFILE,
    title: 'menu.profile',
    to: MobileRouterPaths.profile,
}];
